import React from 'react';
import './ClearHistoryForm.scss';

import { clearHistory, closeClearHistoryForm } from './accountSlice';
import { clearHistoryScore} from "../../Authorization/authSlice";

const ClearHistoryForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 const onSend = () => {
        

        const item = {
            user_id: props.user_id,
                    
        }
        console.log(item);
        dispatch(clearHistory(item));
        dispatch(clearHistoryScore());  
        dispatch(closeClearHistoryForm());

    }


    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
    dispatch(closeClearHistoryForm());

    }


    const render = () => {
        //console.log(this.props.adminState.openInputForms);
       // this.props.accountState.openClearHistoryForm)
        if (true) {
            return(
                <div className="ClearHistoryForm">
                    
                <p><b>Вы действительно хотите очистить историю и начать сначала?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
        } else return null;
   
    }
return render();
}
export default ClearHistoryForm;
  